// Search Spinner Functionality
document.addEventListener('DOMContentLoaded', () => {
  // Create the spinner overlay element
  const spinnerOverlay = document.createElement('div');
  spinnerOverlay.className = 'm-search-spinner-overlay';
  spinnerOverlay.style.display = 'none';
  spinnerOverlay.innerHTML = `
    <div class="m-search-spinner-container">
      <svg class="animate-spin animate-spin-show m-svg-icon--large" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>
  `;
  document.body.appendChild(spinnerOverlay);
  
  // Add CSS for the spinner overlay
  const style = document.createElement('style');
  style.textContent = `
    .m-search-spinner-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.9);
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .m-search-spinner-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .m-search-spinner-container svg {
      width: 25px;
      height: 25px;
      color: #000;
    }
  `;
  document.head.appendChild(style);

  // Flag to prevent infinite loop
  window.skipSearchSpinner = false;

  // Use event delegation to catch all search icon clicks
  document.addEventListener('click', function(event) {
    // Find if the click was on a search button or its child elements
    const searchButton = event.target.closest('[data-open-search-popup]');
    
    if (searchButton) {
      // Check if we should skip the spinner (to avoid infinite loop)
      if (window.skipSearchSpinner) {
        window.skipSearchSpinner = false;
        return;
      }
      
      // Prevent the default action and event bubbling
      event.preventDefault();
      event.stopPropagation();
      
      // Show the spinner
      spinnerOverlay.style.display = 'flex';
      
      // After 1 second, hide spinner and open search popup
      setTimeout(() => {
        // Hide spinner
        spinnerOverlay.style.display = 'none';
        
        // Trigger the search popup opening
        // We need to create a new click event that bypasses our listener
        const searchPopupEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        
        // Set a flag to avoid infinite loop
        window.skipSearchSpinner = true;
        searchButton.dispatchEvent(searchPopupEvent);
      }, 500);
      
      return false;
    }
  }, true);
}); 